import { render, staticRenderFns } from "./CreateRegister.vue?vue&type=template&id=c65abfde"
import script from "./CreateRegister.vue?vue&type=script&lang=js"
export * from "./CreateRegister.vue?vue&type=script&lang=js"
import style0 from "./CreateRegister.vue?vue&type=style&index=0&id=c65abfde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports